module.exports = __webpack_public_path__ + "img/cesta.3913ff1b.svg";